import React, { createContext, useContext, useState, useCallback } from "react";
import { translations } from "@/lib/i18n";

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("ls_lang") || "id");

  const toggleLang = useCallback(() => {
    setLang((prev) => {
      const next = prev === "id" ? "en" : "id";
      localStorage.setItem("ls_lang", next);
      return next;
    });
  }, []);

  const t = useCallback(
    (path) => {
      const parts = path.split(".");
      let node = translations[lang];
      for (const p of parts) {
        node = node?.[p];
      }
      return node ?? path;
    },
    [lang]
  );

  const localizedTitle = useCallback(
    (asset) => (lang === "id" ? asset?.title_id || asset?.title_en : asset?.title_en || asset?.title_id),
    [lang]
  );
  const localizedDesc = useCallback(
    (asset) => (lang === "id" ? asset?.description_id || asset?.description_en : asset?.description_en || asset?.description_id),
    [lang]
  );

  return (
    <I18nContext.Provider value={{ lang, setLang, toggleLang, t, localizedTitle, localizedDesc }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}
